import { lazy } from "react";

const routes = [
  {
    path: "/block",
    element: lazy(() => import("../pages/Block")),
  },
  {
    path: "/block/add",
    element: lazy(() => import("../pages/Block/create")),
  },
  {
    path: "/block/edit/:id",
    element: lazy(() => import("../pages/Block/edit")),
  },
];

export default routes;
